import { makeAutoObservable } from 'mobx';
import {
    FILTER_TYPE,
    SORT_TYPE,
    STEP_TYPE,
    VIEWER_MODE,
} from '../__utils/UiConst';

export class UiManager {
    _libState = null;
    constructor(libState) {
        makeAutoObservable(this);
        this._libState = libState;
    }
    _selectedFilter = FILTER_TYPE.ALL;
    _selectedSorting = SORT_TYPE.NEWEST;
    _selectedViewMode = VIEWER_MODE.GRID;
    _selectedStep = STEP_TYPE.CREATE;
    _isPdfUploadModel = false;
    _isStartingPoint = false;
    _prevSelectedPages = [];

    get selectedFilter() {
        return this._selectedFilter;
    }
    get selectedSorting() {
        return this._selectedSorting;
    }
    get selectedViewMode() {
        return this._selectedViewMode;
    }
    get selectedStep() {
        return this._selectedStep;
    }
    get isStartingPoint() {
        return this._isStartingPoint;
    }
    get isPdfUploadModel() {
        return this._isPdfUploadModel;
    }
    get prevSelectedPages() {
        return this._prevSelectedPages;
    }
    get hasPageSelectionChanged() {
        return !this.arePageSelectionsEqual(
            this._libState.viewManager.selectedPages,
            this.prevSelectedPages,
        );
    }
    setSelectedFilter(filter) {
        this._selectedFilter = filter;
    }
    setSelectedSorting(sort) {
        this._selectedSorting = sort;
    }
    setSelectedViewMode(mode) {
        this._selectedViewMode = mode;
    }
    setSelectedStep(step) {
        this._selectedStep = step;
    }
    setIsStartingPoint(isStartingPoint) {
        this._isStartingPoint = isStartingPoint;
    }
    setIsPdfUploadModel(isPdfUploadModel) {
        this._isPdfUploadModel = isPdfUploadModel;
    }
    setPrevSelectedPages(prevSelectedPages) {
        this._prevSelectedPages = prevSelectedPages;
    }

    arePageSelectionsEqual(a, b) {
        if (a.length !== b.length) return false;

        // Sort both arrays by pageNum for consistent comparison
        const sortedA = [...a].sort((x, y) => x.pageNum - y.pageNum);
        const sortedB = [...b].sort((x, y) => x.pageNum - y.pageNum);

        return sortedA.every(
            (page, index) =>
                page.pageNum === sortedB[index].pageNum &&
                page.name === sortedB[index].name,
        );
    }
    handleStructureData = () => {
        const { viewManager, closetManager } = this._libState;
        const data = [...closetManager.units]
            .sort((a, b) => Number(a._pageNo) - Number(b._pageNo))
            .map((unit) => {
                const page = viewManager.selectedPages.find(
                    (page) => Number(page.pageNum) === Number(unit.pageNo),
                );

                const unitClosets = [...closetManager.closets]
                    .filter((closet) => closet._unitId === unit._id)
                    .map((closet) => {
                        const attachments = closetManager.attachments.filter(
                            (att) => att.closetId === closet._id,
                        );
                        const obstacles = closetManager.obstacles.filter(
                            (obs) => obs.closetId === closet._id,
                        );
                        const internalWalls =
                            closetManager.internalWalls.filter(
                                (wall) => wall.closetId === closet._id,
                            );
                        return {
                            ...closet,
                            attachments,
                            obstacles,
                            internalWalls,
                        };
                    });
                return {
                    ...unit,
                    page,
                    unitClosets,
                };
            });
        return data;
    };
}
